module.exports = __webpack_public_path__ + "static/media/aafiya2.036cdfae.png";